import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "\"I just need an idea\"",
  "description": "",
  "published": "2020-04-20T00:00:00.000Z",
  "redirect_from": ["/blog/i-just-need-an-idea/swizec/9375"],
  "categories": "Opinions, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You know what's the best way to learn a new technology?`}</p>
    <p>{`Build something.`}</p>
    <p>{`You know the best way to stand out as a job applicant?`}</p>
    <p>{`Build something.`}</p>
    <p>{`Best way to make $1000/month on the side?`}</p>
    <p>{`Build something.`}</p>
    <p>{`So why aren't you building something my friend? Why isn't there a little passion project in your life that occupies your nights and weekends? Why aren't you jumping out of bed every morning to do a little hacking before dayjob.exe starts?`}</p>
    <p>{`Let me guess: You don't have an idea?`}</p>
    <p>{`Poppycock.`}</p>
    <h2 {...{
      "id": "i-dont-have-an-idea-is-the-commonest-excuse"
    }}>{`"I don't have an idea" is the commonest excuse`}</h2>
    <p>{`You're not alone.`}</p>
    <p>{`I remember talking to a friend a while ago. She was going through a life transition. Changing jobs, leaving the safety of a startup that jump-started her career, figuring out what to do next.`}</p>
    <p><em parentName="p">{`"Well, what do you want?"`}</em>{`, I asked.`}</p>
    <p><em parentName="p">{`"What I really want is to start a business"`}</em></p>
    <p>{`Okay then do it. You're well connected, just start.`}</p>
    <p><em parentName="p">{`"Yeah but I don't have an idea"`}</em></p>
    <p><img parentName="p" {...{
        "src": "/e404587ac9c9626e20647ec5f0cb20b7/media-4SZxcPTtlGAZa-giphy.gif",
        "alt": "throw_up_hands_give_up giphy"
      }}></img></p>
    <p>{`She got a job at an early-ish stage startup. Owns a product category. Kind of like a baby startup within a startup. It's pretty cool.`}</p>
    <p>{`Hell, a few years ago I was grabbing coffee with a founder friend. Downtown San Francisco, beautiful day, okay coffee. Back then the city felt like an exciting wonderland full of opportunity. The future. Now it just feels like home.`}</p>
    <p><em parentName="p">{`"Swiz, you're wasting time with this freelancing nonsense. You're a great guy, why don't you just start something real?"`}</em></p>
    <p><em parentName="p">{`"I don't have an idea."`}</em></p>
    <p>{`End of conversation.`}</p>
    <h2 {...{
      "id": "why-we-say-we-dont-have-ideas"
    }}>{`Why we say we don't have ideas`}</h2>
    <p>{`I think it's because we're afraid. It's easy to say you don't have an idea.`}</p>
    <p>{`Nobody can fault you for not starting, if you don't have an idea. What're they gonna do? Force you? Point and laugh? Call you silly?`}</p>
    <p>{`No of course not. `}<em parentName="p">{`"I don't have an idea"`}</em>{` ends the conversation.`}</p>
    <p>{`You can't start without an idea.`}</p>
    <p>{`But really, I think you `}<em parentName="p">{`do`}</em>{` have ideas my friend. I think you have plenty of ideas. You're just afraid.`}</p>
    <p>{`Afraid they're not big enough. Afraid you'll fail. Afraid you can't do it. Afraid others will judge you. Afraid you'll waste your time.`}</p>
    <p>{`Afraid.`}</p>
    <p>{`It's easier never to start. Safe in your mind that little kernel of idea stays perfect. Unchanging.`}</p>
    <p>{`Nobody will ever know but you. You always could've been great, you just didn't have an idea.`}</p>
    <p>{`Struck a nerve? Hit reply`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>
    <p>{`PS: tomorrow we'll talk more about ideas and how they work`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      